// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import { useState } from 'react';

export const useIframePolling = () => {
  const [ts, setTs] = useState(0);
  let pollIntervalId: NodeJS.Timer;

  function getNow(): number {
    return Date.now();
  }

  function startIframePolling() {
    pollIntervalId = setInterval(() => {
      // Bump query param for resource at an interval to cache bust
      setTs(getNow());
    }, 2000);
  }

  function stopIframePolling() {
    clearInterval(pollIntervalId);
  }

  return {
    ts,
    startIframePolling,
    stopIframePolling,
  };
};
